(ns assemble.assets-page.upload-modal.db
  "Modal state for upload modal.

  Upload queue itself is in namespace assemble.resource.asset"
  (:require [assemble.component.upload-modal :as upload-modal]
            [assemble.util :as util]
            [re-frame.core :as rf]))

(defn- validate-asset [asset-type {:keys [filename]}]
  (case asset-type
    :fonts (contains? (:exts (:fonts util/file-types)) (util/file-extension filename))
    :logos (contains? (:exts (:image util/file-types)) (util/file-extension filename))
    (util/allowed-file-extension? filename)))

(defn- extend-font-asset [value]
  (assoc value :metadata (util/parse-font-filename (:filename value))))

(rf/reg-event-fx ::open
  [(rf/inject-cofx :sub :assemble.page.assets.file-tree/current-node-id)]
  (fn [{:keys [db] :as cofx} [_ {:keys [files asset-type]}]]
    {:db (assoc db :assets-upload {:modal-open true
                                   :folder-node (:assemble.page.assets.file-tree/current-node-id cofx)
                                   :asset-type asset-type})
     :fx [[:dispatch [::set-queue files]]]}))

(rf/reg-event-db ::close
  (fn [db _]
    ;; Ignore close operation from modal if there is upload in progress.
    ;; Cancel button is additionally disabled visually.
    (let [queue (-> db :assets-upload :queue)
          active-upload (boolean (upload-modal/queue-first-by-status queue "uploading"))]
      (if active-upload
        db
        ;; NOTE: Later we might close the modal, but keep the queue
        ;; state in app db for background uploads.
        ;; Now the queue is also cleared when closing the modal.
        (dissoc db :assets-upload)))))

(rf/reg-event-fx ::set-queue
  (fn [{:keys [db]} [_ files]]
    (let [asset-type (:asset-type (:assets-upload db))
          queue (upload-modal/files->queue
                 files
                 (partial validate-asset asset-type)
                 (if (= :fonts asset-type)
                   extend-font-asset
                   identity))]
      {:db (update-in db [:assets-upload :queue] upload-modal/merge-queue queue)})))

(rf/reg-event-db ::remove-queue-item
  (fn [db [_ id]]
    (update-in db [:assets-upload :queue] upload-modal/remove-queue-item id)))

(rf/reg-sub ::get-queue
  (fn [db]
    (:queue (:assets-upload db))))

(rf/reg-event-db ::set-font-family
  (fn [db [_ font-family]]
    (assoc-in db [:assets-upload :font-family] font-family)))

(rf/reg-sub ::modal-open
  (fn [db]
    (boolean (:modal-open (:assets-upload db)))))

(rf/reg-sub ::props
  (fn [db]
    (:assets-upload db)))
